import type { DepositRegistration } from '@/types/database/depositRegistration';

export const checkIsShowRobotDeliveryButton = (
  deposit: DepositRegistration
) => {
  const isShowRobotDeliveryButton =
    deposit.robotDelivery &&
    deposit.status === '未領取' &&
    deposit.type === '收件';

  return isShowRobotDeliveryButton;
};
